import {
    GET_PERMISSIONS,GET_PERMISSIONS_SUCCESS
  ,
  } from "../../actions/permission/types";
  
  const initialState = {
    
    permissionsLoading:false,
    permissions:[],
    count:0,
    
  };
  

  
  export const permissions = (state = initialState, action)=> {
    const { type, payload } = action;
    switch (type) {
  
      case GET_PERMISSIONS:
          
        return {
          ...state,
          permissionsLoading: true,
        };

        
      case GET_PERMISSIONS_SUCCESS:
      
        return {
          ...state,
          permissionsLoading:false,
          permissions: payload.results,
          
        };
    
  
     
        default: {
          return state;
        }
    }
  }
  